import { InspectionStandardDTO } from "../../../common/types/common.dto.types";

export const GET_INSPECTION_STANDARD_QUESTIONNAIRE_REPORT_DATA =
  "GET_INSPECTION_STANDARD_QUESTIONNAIRE_REPORT_DATA";

const inspectionStandardQuestionnaireSagaActions = {
  getInspectionStandardQuestionnaire: (parameters: InspectionStandardDTO) => {
    return {
      type: GET_INSPECTION_STANDARD_QUESTIONNAIRE_REPORT_DATA,
      payload: parameters,
    };
  },
};

export default inspectionStandardQuestionnaireSagaActions;
